import styled, { css } from 'styled-components';
import { EButtonVariant, EButtonSize } from './config';

// Base button styles
export const ButtonBase = styled.button<{
  $variant: EButtonVariant;
  $size: EButtonSize;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  cursor: pointer;
  border: 1px solid transparent;
  overflow: hidden;

  /* Size variants */
  ${(props) =>
    props.$size === EButtonSize.SM &&
    css`
      height: 32px;
      padding: 0 12px;
      font-size: 12px;
    `}

  ${(props) =>
    props.$size === EButtonSize.DEFAULT &&
    css`
      height: 40px;
      padding: 0 16px;
    `}

  ${(props) =>
    props.$size === EButtonSize.LG &&
    css`
      height: 48px;
      padding: 0 24px;
      font-size: 16px;
    `}

  /* Variant styles */
  ${(props) =>
    props.$variant === EButtonVariant.DEFAULT &&
    css`
      background-color: hsl(221, 83%, 53%);
      color: white;

      &:hover {
        background-color: hsl(221, 83%, 47%);
      }
    `}

  ${(props) =>
    props.$variant === EButtonVariant.DESTRUCTIVE &&
    css`
      background-color: hsl(0, 84%, 60%);
      color: white;

      &:hover {
        background-color: hsl(0, 84%, 50%);
      }
    `}

  ${(props) =>
    props.$variant === EButtonVariant.OUTLINE &&
    css`
      background-color: transparent;
      border-color: hsl(214, 32%, 91%);
      color: hsl(224, 71%, 4%);

      &:hover {
        background-color: hsl(220, 14%, 96%);
      }
    `}

  /* Add other variants (secondary, ghost, link) similarly */

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px hsl(221, 83%, 53%, 0.4);
  }
`;